import React, { useState } from 'react'
import { Trans } from 'gatsby-plugin-react-i18next'
import PropTypes from 'prop-types'

import { Column, Line, CurrentPage, PageLink } from '../../templates/ShopifyPage/styles'
import { MobileToggle, MobileNavContainer, MobileNavContent, MobileNavParent } from './styles'

const pagePathToTitle = {
  '/privacy-policy': 'Privacy Policy',
  '/tos': 'Terms of Service',
  '/sms-terms': 'SMS Terms of Service',
  '/sms-privacy': 'SMS Privacy Policy',
}

function getTitle(rawCurrentRoutePath) {
  const currentRoutePath = rawCurrentRoutePath.replace(/\/$/, '')
  const title = pagePathToTitle[currentRoutePath]
  if (!title) {
    throw new Error(`Unsupported currentRoutePath: ${rawCurrentRoutePath}`)
  }
  return title
}

const TosNav = ({ currentRoutePath }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <Column>
      <MobileNavParent>
        <MobileToggle onClick={() => setIsExpanded(!isExpanded)}>
          <span>{getTitle(currentRoutePath)}</span>
          <span>{isExpanded ? '−' : '+'}</span>
        </MobileToggle>
        <MobileNavContainer isExpanded={isExpanded}>
          <MobileNavContent>
            <Line />
            <BoundPageLink to="/privacy-policy/" currentRoutePath={currentRoutePath}>
              <Trans>{getTitle('/privacy-policy/')}</Trans>
            </BoundPageLink>
            <Line />
            <BoundPageLink to="/tos/" currentRoutePath={currentRoutePath}>
              <Trans>{getTitle('/tos/')}</Trans>
            </BoundPageLink>
            <Line />
            <BoundPageLink to="/sms-terms/" currentRoutePath={currentRoutePath}>
              <Trans>{getTitle('/sms-terms/')}</Trans>
            </BoundPageLink>
            <Line />
            <BoundPageLink to="/sms-privacy/" currentRoutePath={currentRoutePath}>
              <Trans>{getTitle('/sms-privacy/')}</Trans>
            </BoundPageLink>
            <Line />
          </MobileNavContent>
        </MobileNavContainer>
      </MobileNavParent>
    </Column>
  )
}

TosNav.propTypes = {
  currentRoutePath: PropTypes.string.isRequired,
}

const BoundPageLink = ({
  to,
  children,
  // NB: Ideally this wouldn't be a prop but rather a computed value but I'm
  // not sure how Gatsby does that during build. This is simple and easy
  // to understand so I'm leaving it as a prop. -scotty
  currentRoutePath,
}) => {
  const isCurrentPage = currentRoutePath.replace(/\/$/, '') === to.replace(/\/$/, '')
  if (isCurrentPage) {
    return <CurrentPage to={to}>{children}</CurrentPage>
  }
  return <PageLink to={to}>{children}</PageLink>
}

BoundPageLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  currentRoutePath: PropTypes.string.isRequired,
}

export default TosNav
